import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=85ea5738&scoped=true&"
import script from "./AddGroup.vue?vue&type=script&lang=js&"
export * from "./AddGroup.vue?vue&type=script&lang=js&"
import style0 from "./AddGroup.vue?vue&type=style&index=0&id=85ea5738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ea5738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85ea5738')) {
      api.createRecord('85ea5738', component.options)
    } else {
      api.reload('85ea5738', component.options)
    }
    module.hot.accept("./AddGroup.vue?vue&type=template&id=85ea5738&scoped=true&", function () {
      api.rerender('85ea5738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/AddGroup.vue"
export default component.exports